import { createRecipe } from './runtime';

const textConfig = {"name":"text","defaultVariants":{"size":"md"},"variantMap":{"size":["sm","md","lg"]}}

export const text = /* @__PURE__ */ createRecipe(textConfig)